import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { PageForTable } from '../../types'
import { pageForTableFromDTO, sortToDTO } from './api/mapper'
import { GET_PAGES_FOR_TABLE } from './api/query'
import { Data, Variables } from './api/types'
import { PageForTableDTO, UseGetPages, UseGetPagesProps } from './types'

export const useGetPages = ({ filters, first, last, sort }: UseGetPagesProps): UseGetPages => {
  const { workspaceId } = useWorkspaceParam()
  const [pages, setPages] = useState<PageForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async data => {
      const {
        pages: { nodes: pages, totalCount: count },
      } = data

      if (pages) {
        setPages(pages.map((node: PageForTableDTO): PageForTable => pageForTableFromDTO(node)))
        setCount(count)
      }
    },
    query: GET_PAGES_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return { count, loading, pages }
}
